import type { ReactNode } from 'react'

export const GESTOR_TABLE_TH_CLASS =
  'text-left px-4 py-3 text-[var(--font-color-label)] font-medium uppercase tracking-wider'
export const GESTOR_TABLE_TR_CLASS =
  'border-b border-[var(--glass-border)] last:border-0 hover:bg-[var(--glass-bg)] transition-colors cursor-pointer'

export function gestorInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

export function GestorTableAvatar({ name }: { name: string }) {
  return (
    <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[var(--brand-primary-muted)]'>
      <span className='text-[11px] font-bold text-[var(--brand-primary)]'>{gestorInitials(name)}</span>
    </div>
  )
}

type ShellProps = {
  loading?: boolean
  loadingMessage?: string
  empty?: boolean
  emptyIcon?: ReactNode
  emptyTitle?: string
  emptyHint?: string
  children: ReactNode
}

export function GestorListTableShell({
  loading,
  loadingMessage = 'Carregando…',
  empty,
  emptyIcon,
  emptyTitle = 'Nenhum registro encontrado',
  emptyHint,
  children,
}: ShellProps) {
  if (loading) {
    return (
      <div className='glass-card p-8 text-center'>
        <p className='text-sm text-[var(--font-color-muted)]'>{loadingMessage}</p>
      </div>
    )
  }

  if (empty) {
    return (
      <div className='glass-card p-12 text-center'>
        {emptyIcon}
        <p className='font-medium text-[var(--font-color-body)]'>{emptyTitle}</p>
        {emptyHint && (
          <p className='mt-1 text-sm text-[var(--font-color-muted)]'>{emptyHint}</p>
        )}
      </div>
    )
  }

  return (
    <div className='glass-card p-0 overflow-hidden'>
      <div className='overflow-x-auto'>{children}</div>
    </div>
  )
}
